import { EDashboard } from './globalEnums';
import type IEntity from './IEntity';

// TODO: DELETE in Oktober 2025 - Legacy support for old card types
export enum EDashboardWidgetTypes {
    richTextWidget = 'richTextWidget',
    personListWidget = 'personListWidget',
    buttonBoxWidget = 'buttonBoxWidget',
    agentChatWidget = 'agentChatWidget',
    onboardingWidget = 'onboardingWidget',
    notificationWidget = 'notificationWidget',
}

type SpecificWidgetParams<T extends EDashboardWidgetTypes> = T extends EDashboardWidgetTypes.richTextWidget
    ? { text: string }
    : T extends EDashboardWidgetTypes.personListWidget
      ? { employeeIds: number[] }
      : T extends EDashboardWidgetTypes.buttonBoxWidget
        ? { link: string; title: string; description: string }
        : T extends EDashboardWidgetTypes.agentChatWidget
          ? unknown
          : T extends EDashboardWidgetTypes.onboardingWidget
            ? unknown
            : T extends EDashboardWidgetTypes.notificationWidget
              ? unknown
              : never;

// TODO: DELETE in Oktober 2025 - Legacy support
export type WidgetParamsMap = {
    [K in EDashboardWidgetTypes]: SpecificWidgetParams<K>;
};

// TODO: DELETE in Oktober 2025 - Legacy support

export type TWidgetConfig<T extends EDashboardWidgetTypes = EDashboardWidgetTypes> = {
    i: string;
    type: T;
    title: string;
    params: WidgetParamsMap[T];
};

// TODO: DELETE in Oktober 2025 - Legacy support

export interface IDashboardWidgetProps<T extends EDashboardWidgetTypes = EDashboardWidgetTypes> {
    id: string;
    params: WidgetParamsMap[T];
    isEditing: boolean;
    onParamChange: <K extends keyof WidgetParamsMap[T]>(id: string, key: K, value: WidgetParamsMap[T][K]) => void;
}

// TODO: DELETE in Oktober 2025 - Legacy support
export interface IDashboardWidgetProps<T extends EDashboardWidgetTypes = EDashboardWidgetTypes> {
    id: string;
    params: WidgetParamsMap[T];
    isEditing: boolean;
    onParamChange: <K extends keyof WidgetParamsMap[T]>(id: string, key: K, value: WidgetParamsMap[T][K]) => void;
}

export function isEDashboard(value?: string | EDashboard): value is EDashboard {
    if (!value) return false;
    return Object.values(EDashboard).includes(value as EDashboard);
}

// copied from node_modules\@types\react-grid-layout\index.d.ts (damit das Backend nicht das ganze Packet benötigt)
type TLayoutResizeHandle = 's' | 'w' | 'e' | 'n' | 'sw' | 'nw' | 'se' | 'ne';
// copied from node_modules\@types\react-grid-layout\index.d.ts (damit das Backend nicht das ganze Packet benötigt)
export interface ILayoutDashboard {
    /**
     * A string corresponding to the component key.
     * Uses the index of components instead if not provided.
     */
    i: string;

    /**
     * X position in grid units.
     */
    x: number;

    /**
     * Y position in grid units.
     */
    y: number;

    /**
     * Width in grid units.
     */
    w: number;

    /**
     * Height in grid units.
     */
    h: number;

    /**
     * Minimum width in grid units.
     */
    minW?: number | undefined;

    /**
     * Maximum width in grid units.
     */
    maxW?: number | undefined;

    /**
     * Minimum height in grid units.
     */
    minH?: number | undefined;

    /**
     * Maximum height in grid units.
     */
    maxH?: number | undefined;

    /**
     * set by DragEvents (onDragStart, onDrag, onDragStop) and ResizeEvents (onResizeStart, onResize, onResizeStop)
     */
    moved?: boolean | undefined;

    /**
     * If true, equal to `isDraggable: false` and `isResizable: false`.
     */
    static?: boolean | undefined;

    /**
     * If false, will not be draggable. Overrides `static`.
     */
    isDraggable?: boolean | undefined;

    /**
     * If false, will not be resizable. Overrides `static`.
     */
    isResizable?: boolean | undefined;

    /**
     * By default, a handle is only shown on the bottom-right (southeast) corner.
     * Note that resizing from the top or left is generally not intuitive.
     */
    resizeHandles?: TLayoutResizeHandle[] | undefined;

    /**
     * If true and draggable, item will be moved only within grid.
     */
    isBounded?: boolean | undefined;
}

export interface IDashboardDTO extends IEntity {
    id: string;
    description: string;
    layout: string;
    widgets: string;
    cards?: string; // TODO: DELETE in Oktober 2025 - Legacy support
}

// Für die edit-Mutation (ID kommt ja als separater Parameter)
export interface IEditDashboardDTO {
    title: string;
    description?: string;
    layout: string;
    widgets: string;
    cards?: string; // TODO: DELETE in Oktober 2025 - Legacy support
}

export interface ICreateDashboardDTO {
    title: string;
    description?: string;
    layout: string;
    widgets: string;
    cards?: string; // TODO: DELETE in Oktober 2025 - Legacy support
}
